__turbopack_context__.v({
  "LandingPageHeader": "LandingPage-module__HOEfWW__LandingPageHeader",
  "arrowContainer": "LandingPage-module__HOEfWW__arrowContainer",
  "arrowContainerMobile": "LandingPage-module__HOEfWW__arrowContainerMobile",
  "backgroundLines": "LandingPage-module__HOEfWW__backgroundLines",
  "bookAuthor": "LandingPage-module__HOEfWW__bookAuthor",
  "bookCover": "LandingPage-module__HOEfWW__bookCover",
  "bookImageContainer": "LandingPage-module__HOEfWW__bookImageContainer",
  "bookInfo": "LandingPage-module__HOEfWW__bookInfo",
  "bookTitle": "LandingPage-module__HOEfWW__bookTitle",
  "container": "LandingPage-module__HOEfWW__container",
  "coverImage": "LandingPage-module__HOEfWW__coverImage",
  "footer": "LandingPage-module__HOEfWW__footer",
  "generateButton": "LandingPage-module__HOEfWW__generateButton",
  "header": "LandingPage-module__HOEfWW__header",
  "inputWrapper": "LandingPage-module__HOEfWW__inputWrapper",
  "landingPageLogo": "LandingPage-module__HOEfWW__landingPageLogo",
  "landingPageSearch": "LandingPage-module__HOEfWW__landingPageSearch",
  "layoutWrapper": "LandingPage-module__HOEfWW__layoutWrapper",
  "logoContainer": "LandingPage-module__HOEfWW__logoContainer",
  "main": "LandingPage-module__HOEfWW__main",
  "mainContent": "LandingPage-module__HOEfWW__mainContent",
  "mainTitle": "LandingPage-module__HOEfWW__mainTitle",
  "menuButton": "LandingPage-module__HOEfWW__menuButton",
  "menuIcon": "LandingPage-module__HOEfWW__menuIcon",
  "overallContainer": "LandingPage-module__HOEfWW__overallContainer",
  "promptBottom": "LandingPage-module__HOEfWW__promptBottom",
  "promptCenter": "LandingPage-module__HOEfWW__promptCenter",
  "promptContainer": "LandingPage-module__HOEfWW__promptContainer",
  "promptIcon": "LandingPage-module__HOEfWW__promptIcon",
  "promptInput": "LandingPage-module__HOEfWW__promptInput",
  "promptInputWrapper": "LandingPage-module__HOEfWW__promptInputWrapper",
  "promptWrapper": "LandingPage-module__HOEfWW__promptWrapper",
  "searchButton": "LandingPage-module__HOEfWW__searchButton",
  "searchContainer": "LandingPage-module__HOEfWW__searchContainer",
  "searchForm": "LandingPage-module__HOEfWW__searchForm",
  "searchInput": "LandingPage-module__HOEfWW__searchInput",
  "subtitle": "LandingPage-module__HOEfWW__subtitle",
  "suggestionsContainer": "LandingPage-module__HOEfWW__suggestionsContainer",
  "suggestionsGrid": "LandingPage-module__HOEfWW__suggestionsGrid",
  "suggestionsHidden": "LandingPage-module__HOEfWW__suggestionsHidden",
  "suggestionsTitle": "LandingPage-module__HOEfWW__suggestionsTitle",
  "suggestionsVisible": "LandingPage-module__HOEfWW__suggestionsVisible",
  "suggestionsWrapper": "LandingPage-module__HOEfWW__suggestionsWrapper",
  "tickerContainer": "LandingPage-module__HOEfWW__tickerContainer",
  "tickerHidden": "LandingPage-module__HOEfWW__tickerHidden",
  "tickerVisible": "LandingPage-module__HOEfWW__tickerVisible",
  "time": "LandingPage-module__HOEfWW__time",
  "timeContainer": "LandingPage-module__HOEfWW__timeContainer",
  "timeDigit": "LandingPage-module__HOEfWW__timeDigit",
  "timeDisplay": "LandingPage-module__HOEfWW__timeDisplay",
  "timeSeparator": "LandingPage-module__HOEfWW__timeSeparator",
  "timestamp": "LandingPage-module__HOEfWW__timestamp",
  "title": "LandingPage-module__HOEfWW__title",
  "titleCenter": "LandingPage-module__HOEfWW__titleCenter",
  "titleContainer": "LandingPage-module__HOEfWW__titleContainer",
  "titleHidden": "LandingPage-module__HOEfWW__titleHidden",
  "titleTop": "LandingPage-module__HOEfWW__titleTop",
  "titleVisible": "LandingPage-module__HOEfWW__titleVisible",
  "verticalLine": "LandingPage-module__HOEfWW__verticalLine",
  "viewPortOne": "LandingPage-module__HOEfWW__viewPortOne",
});
